import { render, staticRenderFns } from "./EditCompanyCustomFieldDefs.vue?vue&type=template&id=456461ca"
import script from "./EditCompanyCustomFieldDefs.vue?vue&type=script&lang=ts"
export * from "./EditCompanyCustomFieldDefs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports